import { forwardRef, useContext, useEffect, useRef, useState } from "react";
import { ModalElementContext } from "src/context/modal-element-context";
import classes from "./SearchFormText.module.css";

const SearchFormText = forwardRef(function SearchFormText(
  { id, value, label, onClick, className, icon: Icon },
  ref,
) {
  const { onClose } = useContext(ModalElementContext);
  const frameRef = useRef(null);
  const [hasInput, setHasInput] = useState(false);

  useEffect(() => {
    setHasInput(!!value);
  }, [value]);

  return (
    <label
      ref={(r) => {
        frameRef.current = r;
        if (ref) {
          ref["passengers"] = r;
        }
      }}
      htmlFor={id}
      className={`${classes.frame} ${className ?? ""} ${Icon ? classes.hasIcon : ""} frame-sf-field`}
      onClick={() => onClick()}
      onKeyDown={(e) => {
        if (["Tab", "Escape"].includes(e.key)) onClose();
        if (e.key === "Enter") onClick();
      }}>
      {Icon && <Icon size={18} stroke={1.75} className={classes.leftIcon} />}
      <span
        className={hasInput ? classes.smallText : classes.bigText}
        onClick={(e) => e.stopPropagation()}>
        {label}
      </span>
      <input id={id} type="text" readOnly value={value} hidden={!value} />
    </label>
  );
});

export default SearchFormText;
